import { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';
import Loading from '../util/Loading';
import './ProductDetail.css';

const decodeHtmlEntities = (str) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = str;
  return textarea.value;
};

const addImgLazyLoad = (html) => {
  return html.replace(/<img /g, '<img loading="lazy" ');
}

const ProductDetail = ({ goodsSeq }) => {
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
          setLoading(true);
          let { data: product, error } = await supabase
            .from('tb_store_goods')
            .select('goods_seq, store_type_cd, category_id, brand_cd, display_goods_name, discount_price, price, thumbnail1_image_url, goods_info, detailinfo')
            .eq('goods_seq', goodsSeq)
            .single();
    
          if (error) {
            console.error('Error fetching data:', error);
          } else {
            console.log(product);
            setProduct(product);
          }
          setLoading(false);
        };
        fetchData();
      }, [goodsSeq]); // 빈 배열이면 컴포넌트 마운트 시 1회 실행

    if (loading) {
        return (
          <Loading message="상품 정보를 불러오는 중..." />
        );
    }

    if (!product) {
        return <div className="error-message">상품을 찾을 수 없습니다.</div>;
    }

    return (
        <div className="detail-wrap">

            <div className="detail-image-container">
                <img className ="product-thumbnail" src = {"https://cdn.cokeplay.cocacola.co.kr" + product.thumbnail1_image_url} alt=""/>
            </div>

            <div className="detail-basic">
		        <div className="detail-name">{product.display_goods_name}</div>
                <div className="detail-price">
                    <div className="price">
                        {product.discount_price != null ? (
                            <>
                                <div className="price-discount-rate">
                                    <span>{Math.round(((product.price - product.discount_price) / product.price) * 100)}</span>
                                    <em>%</em>
                                </div>
                                <div className="price-discounted">
                                    <span>{product.discount_price.toLocaleString()}</span>
                                    <em>원</em>
                                </div>
                                <div className="price-prime">
                                    <span>{product.price.toLocaleString()}</span>
                                    <em>원</em>
                                </div>
                            </>
                        ) : (
                            <span className="price-prime">
                                <span>{product.price.toLocaleString()}</span>
                                <em>원</em>
                            </span>
                        )}
					</div>
				</div>
                <div className="item-delivery">
                    <div>
                        <label>배송비</label>
                        <div><span className="fc-red">무료배송</span><br/>단, 제주/도서산간 및 일부 지역 추가운임 발생</div>
                    </div>
                    <div>
                        <label>배송 기간</label>
                        <div>제품 출고 후 평일 기준 배송 <span className="fc-red">1~3일</span> 소요</div>
                    </div>
                </div>
            </div>

            <div className="detail-info-area">
                <div className="detail-info-area-title">상품정보</div>
                <div dangerouslySetInnerHTML={{ __html: addImgLazyLoad(decodeHtmlEntities(product.goods_info)) }} />
            </div>
        </div>
    )
}

export default ProductDetail;

